import { faEyeDropper } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useState } from "react";
import { HexColorPicker } from "react-colorful";
import OutsideClick from "../outside-click/outside-click";

interface ColorPickerInputProps {
    width?: string;
    onChange: (color: string) => void;
    color: string
}

const ColorPickerInput: FC<ColorPickerInputProps> = ({ onChange, color }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return <>
        <OutsideClick onClick={() => setIsOpen(false)}>
            <button 
                id = 'colorButton'
                type='button'
                style={{ backgroundColor: color }}
                className="p-2 px-2 flex justify-end flex-row text-sm min-width-68 rounded border-black border-2"
                onClick={() => setIsOpen(!isOpen)}>
                    <FontAwesomeIcon icon={faEyeDropper} size={"sm"} className={`${color === "#FFFFFF" ? 'text-black' : 'text-white'}`} />
            </button>
            <div
                className={`bg-transparent px-2 py-2 selection-content-list overflow-y-auto ${isOpen ? '' : 'hidden'}`}
                style={{ position: 'absolute', zIndex: 999999 }}>
                <HexColorPicker id='colorPicker' hidden={isOpen} color={color} onChange={onChange} />
            </div>
        </OutsideClick>
    </>
}

export default ColorPickerInput;